import React from "react";
import { Alert, Container } from "reactstrap";
import { RiErrorWarningFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import "./notification.scss";

export default function AddPointNotification({ visible, onDismiss }) {
  return (
    <div className="add_point_notification">
      <Container fluid>
        <Alert isOpen={visible} toggle={onDismiss}>
          <div className="notifaction">
            <span className="icon">
              <RiErrorWarningFill size={24} className="aleart_icon" />{" "}
            </span>
            <span className="content">
              "It appears your balance is low. Add more credits to continue
              enjoying additional Benefits"
            </span>
          </div>
          <Link to="/points" className="btn">
            Buy Credits
          </Link>
        </Alert>
      </Container>
    </div>
  );
}
